
import { Component, Prop, Vue } from 'vue-property-decorator';

// Enums
import ButtonColorsEnum from '@/ship/Enums/ButtonColorsEnum';

// Components
import VSpinner from '@/components/VSpinner.vue';

@Component({
    inheritAttrs: false,
    components: { VSpinner },
})
export default class VButton extends Vue {
    @Prop({ type: [String, Object], default: ButtonColorsEnum.Primary })
    public color!: ButtonColorsEnum | null;

    // Makes the background transparent and applies a thin border
    @Prop({ type: Boolean, default: false })
    public outlined!: boolean;

    @Prop({ type: Boolean, default: false })
    public fluid!: boolean;

    @Prop({ type: Boolean, default: false })
    public disabled!: boolean;

    // Applies active style as it is focused.
    @Prop({ type: Boolean, default: false })
    public active!: boolean;

    @Prop({ type: Boolean, default: false })
    public loading!: boolean;

    // Makes the component small
    @Prop({ type: Boolean, default: false })
    public small!: boolean;

    // Specify a custom tag used on the root element.
    @Prop({ type: String, default: 'button' })
    public tag!: string;

    // Applies the dark theme variant to the component.
    @Prop({ type: Boolean, default: false })
    public dark!: boolean;

    // Applies the light theme variant to the component.
    @Prop({ type: Boolean, default: false })
    public light!: boolean;

    public get blocked() {
        return this.disabled || this.loading;
    }

    public get classes() {
        return [
            'v-button',
            this.color ? `v-button--${this.color}` : null,
            {
                'v-button--fluid': this.fluid,
                'v-button--disabled': this.blocked,
                'v-button--active': this.active,
                'v-button--small': this.small,
                'v-button--outlined': this.outlined,
                'v-button--loading': this.loading,
            },
        ];
    }
}
